import Client from './client';

export default class ShopifyMonitoringOrderMonitorReviews extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/shopify/monitoring/order/monitor/reviews`, options);
  }

  putStatusByIdAndStatus(id, status, options = {}) {
    return this.makeRequest(`${this.host}/internal/shopify/monitoring/order/monitor/reviews/${id}/status/${status}`, {
      ...options,
       method: 'PUT',
    });
  }

}
